/**
 *	Enables addtional functionality for the GOLF site. It creates an incremented value for
 *	the position variable, and adds additional targeting to ad slots
 *	@param {MCPInstance} MCP
 */
export default function (MCP) {
	MCP.loaded.then(() => {
		if (MCP.Configurator.meta.page.site !== 'golfdigest') return;

		// Add the targeting to the ad slots before they are refreshed
		const addTargetingBeforeRefresh = ({ slots, preventDefault }) => {
			Array.from(slots.values()).forEach((slot) => {
				slot.setTargeting('ctx_slot_type', slot.type);
				slot.setTargeting('pos', slot.meta.position);
				if (!slot.getTargeting('ctx_slot_rn').length) slot.setTargeting('ctx_slot_rn', '0');

				// Looks for the sponsored flag on the slot element and adds it as targeting, if found
				if (slot.element && slot.element.dataset && slot.element.dataset.gdAdtag !== undefined) {
					const sponsor = slot.element.dataset.gdAdtag;
					if (sponsor.length > 0) {
						slot.setTargeting('sponsor', slot.element.dataset.gdAdtag);
					} else {
						slot.clearTargeting('sponsor');
						slot.clear();
						preventDefault();
					}
				}
			});
		};

		MCP.addEventListener('beforeRefreshSlots', addTargetingBeforeRefresh);
	});
}
